// Сбор пунктов контекст-меню сообщения по правам (SPEC §4.2.context). Презентационно меню рисует
// design-system (ContextMenu); КАКИЕ пункты доступны — решает app-ui: «ответить»/«копировать»/
// «переслать»/реакции — всегда; «изменить»/«удалить у всех» — только автору (для админа группы —
// удаление по политике); «удалить у себя» — всегда. Тумбстоун/системное — только «удалить у себя».
// BR-10: пришедшее из Telegram (origin) правится и удаляется только там — без «Изменить» и «Удалить у
// всех» даже у сопоставленного автора и админа (сервер отвечает FORBIDDEN external_origin).

import type { Message, MemberRole } from '@tele-chat/shared-contracts'
import type { ContextMenuItem } from '@tele-chat/design-system'
import { strings } from '../i18n/strings.js'
import { isExternal } from './origin.js'

export const MSG_ACTION = {
  reply: 'reply',
  forward: 'forward',
  edit: 'edit',
  deleteAll: 'delete-all',
  deleteSelf: 'delete-self',
  copy: 'copy',
} as const

export type MsgActionId = (typeof MSG_ACTION)[keyof typeof MSG_ACTION]

export interface MenuRights {
  /** Текущий пользователь — автор сообщения. */
  isAuthor: boolean
  /** Роль текущего пользователя в чате (для удаления админом по политике). */
  myRole?: MemberRole
}

/**
 * Пункты меню для сообщения. `message` — committed Message (по нему смотрим kind/тумбстоун/текст).
 * Чистая — её проверяет инвариант-тест прав (автор видит edit/delete-all, чужой — нет).
 */
export function messageMenuItems(message: Message, rights: MenuRights): ContextMenuItem[] {
  const items: ContextMenuItem[] = []
  const isDeleted = message.deletedAt !== undefined
  const isSystem = message.kind === 'system'

  if (isDeleted || isSystem) {
    // У тумбстоуна/системного — только скрыть у себя.
    items.push({ id: MSG_ACTION.deleteSelf, label: strings.message.deleteForMe, icon: 'trash' })
    return items
  }

  items.push({ id: MSG_ACTION.reply, label: strings.message.reply, icon: 'reply' })
  items.push({ id: MSG_ACTION.forward, label: strings.message.forward, icon: 'forward' })

  if (message.text !== undefined && message.text.length > 0) {
    items.push({ id: MSG_ACTION.copy, label: strings.message.copy, icon: 'copy' })
  }

  const external = isExternal(message)
  if (rights.isAuthor && message.kind === 'text' && !external) {
    items.push({ id: MSG_ACTION.edit, label: strings.message.edit, icon: 'edit' })
  }

  const canDeleteForAll =
    !external && (rights.isAuthor || rights.myRole === 'owner' || rights.myRole === 'admin')
  if (canDeleteForAll) {
    items.push({
      id: MSG_ACTION.deleteAll,
      label: strings.message.deleteForAll,
      icon: 'trash',
      danger: true,
    })
  }
  items.push({ id: MSG_ACTION.deleteSelf, label: strings.message.deleteForMe, icon: 'trash' })

  return items
}

/** Быстрые реакции по умолчанию (ряд сверху контекст-меню). */
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏']
